import type { ReactNode } from "react";
import { Modal } from "antd";
import { BellOutlined, CloseOutlined } from "@ant-design/icons";
import { useViewport } from "../../hooks/useViewport";
import { modalStyles, modalWrapStyle } from "../../utils/modalStyles";

interface PushModalShellProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  closeLabel: string;
  children: ReactNode;
}

// Общият шел (cloudts-design/references/modals.md) за двата push модала:
// хедър с икон чип + заглавие + подзаглавие + close чип; тялото е children.
// Esc и клик на фона се поемат от antd Modal (onCancel) — без custom handler.
export default function PushModalShell({
  open,
  onClose,
  title,
  subtitle,
  closeLabel,
  children,
}: PushModalShellProps) {
  const { isMobile, isNarrow, isTablet } = useViewport();
  const width = isMobile ? undefined : isTablet ? 420 : 460;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      destroyOnHidden
      width={width}
      styles={modalStyles}
      style={modalWrapStyle}
    >
      <div className="bg-surface text-ink">
        <div
          className={`flex items-start gap-3 border-b border-shade-2 ${
            isNarrow ? "px-4 py-3.5" : "px-6 py-5"
          }`}
        >
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-brand-tint">
            <BellOutlined className="text-[20px] text-brand-deep-ink" />
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="m-0 text-[18px] font-bold leading-[1.2] tracking-[-0.3px] text-ink">
              {title}
            </h2>
            <p className="m-0 mt-1 text-[13px] font-medium leading-[1.4] text-body">
              {subtitle}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label={closeLabel}
            className="flex h-[30px] w-[30px] shrink-0 cursor-pointer items-center justify-center rounded-md border-none bg-transparent text-muted transition-colors duration-150 hover:bg-shade-1 hover:text-ink"
          >
            <CloseOutlined className="text-[14px]" />
          </button>
        </div>

        <div className={isNarrow ? "p-4" : "px-6 pb-6 pt-5"}>{children}</div>
      </div>
    </Modal>
  );
}
